import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';

export function NotFoundPage() {
  return (
    <section className="not-found">
      <Seo title="Page not found" description="The requested page could not be found." />
      <div className="container narrow">
        <p className="eyebrow">404 error</p>
        <h1>This page isn’t here.</h1>
        <p>It may have moved, or the address may be incorrect.</p>
        <Link className="button" to="/">Return home</Link>
      </div>
    </section>
  );
}
